module.exports = __webpack_public_path__ + "media/images/2-7bd0d772.png";